"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

exports.isAllowed = function (_ref, permissions) {
  var resource = _ref.resource,
      type = _ref.type,
      permission = _ref.permission,
      field = _ref.field;

  if (!resource || !permission) {
    return false;
  }

  var path = [type, resource, 'permission', permission, 'allow'];

  if (field) {
    path.pop();
    path.push('fields', field);
  }

  return R.pathOr(true, path, permissions);
};